import { useState } from "react";
import { toast } from "../../../../components/Toast/toast";
import ConfirmModal from "../../../../components/Modals/ConfirmModal";
import SmtpServerView from "./SmtpServerView";
import SmtpServerForm from "./SmtpServerForm";

const SmtpServerPage = () => {
  const [smtp, setSmtp] = useState(null);
  const [editing, setEditing] = useState(false);
  const [confirmReset, setConfirmReset] = useState(false);

  const handleSave = async (payload) => {
    const saved = { ...payload };
    delete saved.password;
    setSmtp(saved);
    toast.success("SMTP settings updated.");
    return true;
  };

  const handleReset = () => {
    setSmtp(null);
    setConfirmReset(false);
    toast.success("Switched back to the default SMTP server.");
  };

  if (editing) {
    return <SmtpServerForm smtp={smtp} onSave={handleSave} onCancel={() => setEditing(false)} />;
  }

  return (
    <>
      <SmtpServerView smtp={smtp} onEdit={() => setEditing(true)} onReset={() => setConfirmReset(true)} />
      {confirmReset && (
        <ConfirmModal
          title="Reset to default SMTP"
          message="System emails will go out through the default mail server again, and your SMTP details will be removed."
          confirmText="Reset"
          tone="warning"
          onCancel={() => setConfirmReset(false)}
          onConfirm={handleReset}
        />
      )}
    </>
  );
};

export default SmtpServerPage;